module.exports = __webpack_public_path__ + "img/setupnolcardgap-min.345ac068.jpg";